// @core/api/endpoints/team/cancel_role_delegation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CancelRoleDelegationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Cancel role delegation
 * Performs cancel operation on role delegation.
 */
export async function CancelRoleDelegation(
  team_id: string,
  delegation_id: string,
  data: CancelRoleDelegationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/delegations/:delegation_id/cancel`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':delegation_id', encodeURIComponent(delegation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
